var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { useTranslation } from 'react-i18next';
import StatusTag from './StatusTag';
import { decamelize } from '../../utils/camelize';
export var getStatus = function (order) {
    if (order.status !== 'confirmed')
        return order.status;
    if (order.transportStatuses) {
        return order.transportStatuses.length === 1
            ? order.transportStatuses[0]
            : order.transportStatuses;
    }
    return order.status;
};
var OrderStatusTag = function (_a) {
    var order = _a.order;
    var t = useTranslation().t;
    var labels = __assign(__assign({}, t('params.order.statuses', { returnObjects: true })), t('params.transportToWarehouse.statuses', { returnObjects: true }));
    var statusLabels = Object.fromEntries(Object.entries(labels).map(function (_a) {
        var k = _a[0], v = _a[1];
        return [decamelize(k), v];
    }));
    var status = getStatus(order);
    if (Array.isArray(status)) {
        return React.createElement(React.Fragment, null, "-");
    }
    return React.createElement(StatusTag, { className: order.status }, statusLabels[status]);
};
export default OrderStatusTag;
